/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacSagittarius = [
  ["path", { d: "M15 3h6v6" }],
  ["path", { d: "M21 3 3 21" }],
  ["path", { d: "m9 9 6 6" }]
];

export { ZodiacSagittarius as default };
//# sourceMappingURL=zodiac-sagittarius.js.map
